import React, { PureComponent } from "react";
import { Link, withRouter } from "react-router-dom";
import Service from "@base/service";
import Midia from "@components/Midia";
import { triggerScroll } from "@base/scroll";

import "./Midia.less";

class MidiaPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      midia: null,
    };
    this.service = new Service();
  }

  render() {
    if (!this.state.midia) return null;
    return (
      <div className="Midia-page">
        <Link
          className="botao"
          to={`/playlist/${this.props.match.params.playlist_id}?scroll=${this.props.match.params.midia_id}`}
          onClick={triggerScroll}
        >
          <button type="button">‹ Voltar</button>
        </Link>
        <Midia
          iframe={true}
          id={this.props.match.params.midia_id}
          idPlaylist={this.props.match.params.playlist_id}
          imagem={this.state.midia.image}
          titulo={this.state.midia.title}
          url={this.state.midia.url}
          descricao={this.state.midia.description}
          play={true}
        />
      </div>
    );
  }

  async componentDidMount() {
    const radio = await this.service.getRadio();
    const playlists = radio.playlists.filter(
      (playlist) =>
        playlist.id.toString() === this.props.match.params.playlist_id
    );
    if (playlists.length === 1) {
      const videos = playlists[0].videos.filter(
        (video) => video.id.toString() === this.props.match.params.midia_id
      );
      if (videos.length === 1) {
        this.setState({ midia: videos[0] });
      }
    }
  }
}

export default withRouter(MidiaPage);
